import React from 'react';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react-lite';
import { useStores } from '@stores';
import { useFiltersPage } from '@app/hooks';
import FilterItem from '@components/Filters/FilterItem';
import { Title, FiltersWrapper, FilterItemWrapper } from './styles';
import Wrapper from '@components/Wrapper';
import { PAGE_PADDING_TOP } from '@constants';

const FiltersPage = () => {
  const {
    contentStore: { eventData },
  } = useStores();

  const { filtersContent, keywords } = useFiltersPage(eventData);

  return (
    <Wrapper padding={`${PAGE_PADDING_TOP}px 20px 20px`}>
      <Helmet>
        <meta name="Keywords" content={keywords} />
      </Helmet>
      <Title>Photo Filters</Title>

      <FiltersWrapper>
        {filtersContent.map((group: any, index: number) => (
          <React.Fragment key={index}>
            {group.map((filter: any) => (
              <FilterItemWrapper key={filter.id}>
                <FilterItem
                  filter={filter}
                  imgHeight={276}
                  circleSize={75}
                  marginBottom={40}
                />
              </FilterItemWrapper>
            ))}
          </React.Fragment>
        ))}
      </FiltersWrapper>
    </Wrapper>
  );
};

export default observer(FiltersPage);
